<template>
	<div class="Container">
		<div class="DqsFlex">
			<div class="DqsHolder">
				<dqs
					:calculated-dqs="totalScore"
					:stroke-dash-array="totalPossibleScore"
					:stroke-color="strokeColor"
					:is-visible="dqsIsVisible"
				/>
			</div>
			<div class="DqsHelper">
				<span class="DqsTitle">Data Quality Score</span>
				<span class="DqsExplanation">
					<span class="DqsExplanationText">Overall study average</span>
					<tooltip :tooltip-message="tooltipMessage" />
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import dqs from "@/components/dqs";
import tooltip from "@/components/tooltip";
import { dqsDefaultLogic } from "@/mixins/dqs-default-logic";
import dataAccessLayer from "@/data-access-layer/data-access-layer";

export default {
	name: "AvgOfStudies",
	components: { dqs, tooltip },
	mixins: [dqsDefaultLogic],
	computed: {
		tooltipMessage(){

			return 'This number represents the average Data Quality Score of all the studies that are currently displayed within this organisation.';
		}
	},
	created(){

		window.addEventListener('studyIdsLoaded', (e) => {

			this.dqsIsVisible = false;
			this.newStudyIds(e);
		})
	},
	methods: {

		newStudyIds(event){
			this.viewApiCall = `${this.apiUrl}/avg?organisationId=${this.requestId}&ids=${event.detail}`;
			this.apiCall();
		},

		async apiCall(){

			let dqsData = await dataAccessLayer.get(this.viewApiCall);

			if(dqsData.averageScore){

				dqsData = dqsData.averageScore;
			}

			this.prepareTotalScore(dqsData);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../styles/main';

.Container {
	width: 90%;
	height: 4rem;
	margin: 0.4rem 0;

	.DqsFlex{
		display: flex;
		align-items: center;
		width: 210px;

		.DqsHolder{
			height: 4rem;
			width: 4rem;
			float: left;
			margin: 0 0.25rem 0 0;
		}

		.DqsHelper{
			@include FontSize(S);
			float: left;
			margin: 0;
			width: 142px;
		}

		.DqsTitle{
			display: block;
		}

		.DqsExplanationText{
			font-weight: bold;
		}
	}
}
</style>
